import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";

import {
  Box,
  Paper,
  Grid,
  Button,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import { Link } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SendIcon from "@mui/icons-material/Send";
import Serverurl from "./Apiurl";
import SubmitIcon from "./images/SUBMIT-ICON.jpg";  
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
export default class PaymentInsertForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectarrauto: [],
pi_id:"",
      selectedProjectInsert: null,
      pi_pj_id: "",pi_date: dayjs(),
      pi_amount: "",submitbtn:"Submit",
      pi_mode: "",paybill:'',previocn:"",
      pi_remarks: "",
      finalized_amount: 0, successMsg: "",
total_paid: 0, errormessage:'',erropen:false,isDisabled:false,errorty:"error",
outstanding_amount: 0,	 
userid: sessionStorage.getItem("userid") || 0
    };
  }
  loadOutstanding = (pj_id) => {
axios
  .get(
    Serverurl +
      "ajaxprojects.php?action=getprojectoutstanding&pj_id=" +
      pj_id
  )
    .then((res) => {
      const data = res.data?.[0] || {};

      this.setState({
        total_paid: data.total_paid || 0,
        outstanding_amount: data.outstanding_amount || 0
      });
    });
};
loadPayment = (id) => {
  axios
    .get(
      Serverurl +
      "ajaxpaymentin.php?action=getall&pi_id=" +
      id
    )
    .then((res) => {
      if (res.data.length > 0) {
        const r = res.data[0];

        this.setState({
          pi_id: r.pi_id,
          selectedProjectInsert: {
            title: r.pj_projectname,
            pj_id: r.pi_pj_id
          },
		  finalized_amount:r.pj_finalizedamount,
          pi_pj_id: r.pi_pj_id,
          pi_date: dayjs(r.pi_date),
          pi_amount: r.pi_amount,
          pi_mode: String(r.pi_mode),
          pi_remarks: r.pi_remarks
        });

        this.loadOutstanding(r.pi_pj_id);
      }
    });
};
componentDidMount() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("pi_id");

  if (id) {
    this.loadPayment(id);
  }
}

  /* PROJECT AUTOEXTENDER */
  onloadProjectBind = (event) => {
axios.get(
  Serverurl +
    "ajaxprojects.php" +
    "?action=getallprojectautoextender" +
    "&pj_isactive=0&projectname=" +
    encodeURIComponent(event.target.value)
)
      .then((res) => {
        
        const list = (res.data || []).map((r) => ({
          title: r.pj_projectname,
          pj_id: r.pj_id,
          finalized: r.pj_finalizedamount   
        }));

        this.setState({ projectarrauto: list });
      });
  };

  onProjectChange = (event, value) => {
  this.setState(
    {
      selectedProjectInsert: value,
      pi_pj_id: value ? value.pj_id : "",
      finalized_amount: value ? value.finalized : 0
    },
    () => {
      if (value?.pj_id) {
        this.loadOutstanding(value.pj_id);
      }
    }
  );
};
updateCustomer = () => {
	
	
	
if(this.state.pi_pj_id==="")
{
	
	this.setState({errormessage:"Please Select Project ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
  if (!this.state.pi_amount || Number(this.state.pi_amount) <= 0) {
this.setState({errormessage:"Please Enter Valid Amount ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
  
    if (this.state.pi_mode==="") {
this.setState({errormessage:"Please Select Mode of Payment",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
this.setState({isDisabled:true,errormessage:"",erropen:false,submitbtn:"Processing...",});
  let formData = new FormData();

  formData.append("action", "update");
  formData.append("pi_id", this.state.pi_id);
  formData.append("pi_pj_id", this.state.pi_pj_id);
  formData.append("pi_date", this.state.pi_date.format("YYYY-MM-DD"));
  formData.append("pi_amount", this.state.pi_amount);
  formData.append("pi_mode", this.state.pi_mode);
  formData.append("pi_remarks", this.state.pi_remarks);
  formData.append("userid", this.state.userid);

  axios.post(Serverurl + "ajaxpaymentin.php", formData).then(() => {
    this.setState({
    isDisabled:false,errormessage:"Payment completed successfully!",erropen:true,
    });

  
  });
};
insertPayments = () => {
 
if(this.state.pi_pj_id==="")
{
	
	this.setState({errormessage:"Please Select Project ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
  if (!this.state.pi_amount || Number(this.state.pi_amount) <= 0) {
this.setState({errormessage:"Please Enter Valid Amount ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
  
    if (this.state.pi_mode==="") {
this.setState({errormessage:"Please Select Mode of Payment",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
this.setState({isDisabled:true,errormessage:"",erropen:false,submitbtn:"Processing..."});


  let formData = new FormData();
  
  if(this.state.pi_id!=="")
  {
  formData.append("action", "update");
  formData.append("pi_id", this.state.pi_id);  
  }else{
  formData.append("action", "insert");
    formData.append("pi_id", 0);  
  }
  formData.append("pi_pj_id", this.state.pi_pj_id);
  formData.append("pi_date", this.state.pi_date.format("YYYY-MM-DD"));
  formData.append("pi_amount", this.state.pi_amount);
  formData.append("pi_mode", this.state.pi_mode);
  formData.append("pi_remarks", this.state.pi_remarks);
  formData.append("userid", this.state.userid );

  
  if(this.state.paybill!='')
	  {
		  
		for (const key of Object.keys(this.state.paybill)) {
            formData.append('Filedata', this.state.paybill[key])
        } 
 formData.append('pi_bill','1')		
	  }else
	  {
		 formData.append('pi_bill',this.state.previocn)	  
	  
	  }

  axios.post(Serverurl + "ajaxpaymentin.php", formData).then(() => {
    
    this.setState({
 
isDisabled:false,errormessage:"Payment completed successfully!",erropen:true,
submitbtn:"Submit",errorty:"success",
      selectedProjectInsert: null,
      pi_pj_id: "",
      pi_date: dayjs(),
      pi_amount: "",
      pi_mode: "",
      pi_remarks: "",
      finalized_amount: 0,
      total_paid: 0,
      outstanding_amount: 0
    });

  
  });
};

onFileChange = (e) => {
  let imageFile = e.target.files[0];

  if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
    this.setState({
      errormessage: "Please select a valid file (jpg, jpeg, png).",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  if (imageFile.size > 916800) {
    this.setState({
      errormessage: "File size should be less than or equal to 900KB.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  this.setState({ paybill: e.target.files, errormessage: "", open: false });
}

  render() {
    return (
	<React.Fragment>
	 <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
  } severity={this.state.errorty}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div>

      <div className="paytxtbox">
        <p>Project</p>
       <p> <Autocomplete
          options={this.state.projectarrauto}
          value={this.state.selectedProjectInsert}
          onChange={this.onProjectChange}
          getOptionLabel={(o) => o.title || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              onChange={this.onloadProjectBind}
            />
          )}
        /></p>
      </div>
       {this.state.selectedProjectInsert && (
        <div className="paytxtbox">
          <p
            style={{
              color:
                this.state.finalized_amount > 0 ? "green" : "gray",
              fontWeight: 500
            }}
          >
            Finalized Amount: ₹ {this.state.finalized_amount}
          </p>
        </div>
      )}
       <div className="txtprojfrm">
        <p>Date</p>
        <DatePicker
		disableFuture
          value={this.state.pi_date}
          onChange={(v) => this.setState({ pi_date: v })}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true
            }
          }}
          format="DD/MM/YYYY"
        />
      </div>
	    <div className="txtprojfrmryt">
		<>
		<p>Upload Bill</p>
		<p className="upload-submitimg"><Button variant="standard" className="upldbtn" endIcon={<PhotoCamera />}>
  Upload
</Button>
<input type="file"  name="paybill"   onChange={this.onFileChange}  accept="image/*;capture=camera" /></p>
	<br/>{this.state.previocn!=="" &&(
	<p><img src={Serverurl+'uploads/' + this.state.previocn } target='_blank' style={{'width':'90px'}}/></p>
	)}
</>
		</div>
	  <div className="clear"></div>
      <div className="amtModeSection">
  
   <div className="paytxtbox" style={{ flex: 1 }}>
    <p>Amount</p>
    <TextField
      fullWidth
      size="small"
      value={this.state.pi_amount}
      onChange={(e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
          this.setState({ pi_amount: value });
        }
      }}
    />
	 {this.state.selectedProjectInsert && (
      <p style={{ color: "red", marginTop:10}}>
        Outstanding Amount: ₹ {this.state.outstanding_amount}
      </p>
    )}
  </div>

   <div className="paytxtbox">
    <p>Mode of Payment</p>

    <ul
      className="paymodelist"
    >
      <li  >
        <label>
          <Radio
            checked={this.state.pi_mode === "1"}
            value="1"
            onChange={(e) =>
              this.setState({ pi_mode: e.target.value })
            }
          />
          Cash
        </label>
      </li>

      <li  >
        <label>
          <Radio
            checked={this.state.pi_mode === "2"}
            value="2"
            onChange={(e) =>
              this.setState({ pi_mode: e.target.value })
            }
          />
          Bank Transfer
        </label>
      </li>

      <li  >
        <label>
          <Radio
            checked={this.state.pi_mode === "3"}
            value="3"
            onChange={(e) =>
              this.setState({ pi_mode: e.target.value })
            }
          />
          UPI
        </label>
      </li>

      <li  >
        <label>
          <Radio
            checked={this.state.pi_mode === "4"}
            value="4"
            onChange={(e) =>
              this.setState({ pi_mode: e.target.value })
            }
          />
          Cheque
        </label>
      </li>
    </ul>
  </div>
</div>
       <div className="paytxtbox">
        <p>Remarks</p>
        <TextField
		
          fullWidth
          size="small"
          multiline
          rows={3}
          value={this.state.pi_remarks}
          onChange={(e) =>
            this.setState({ pi_remarks: e.target.value })
          }
        />
      </div>
<div className="aligncenter">
  <Button
    endIcon={
      <img
        src={SubmitIcon}
        alt="Submit"
        style={{ width: 20, height: 20 }}
      />
    } disabled={this.state.isDisabled}
    variant="contained"
    onClick={
      
	this.insertPayments}
  
  >
    {this.state.submitbtn}
  </Button>

  {this.state.successMsg && (
    <p
      style={{
        color: "green",
        marginTop: "8px",
      }}
    >
      {this.successMsg || this.state.successMsg}
    </p>
  )}
</div>
    </div>
  </LocalizationProvider></React.Fragment>
    );
  }
}

